import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import EditAlbumModal from "../../Models/EditAlbumModel/editAlbum";
import { deleteUpdate, albumGet } from "../../apis/api/GalleryApis";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Lodderr from "../../components/Lodder/Lodder";
import { useLocation } from "react-router-dom";
const AlbumsCard = () => {
  const company_id = Cookies.get("company_id");
  const UserID = Cookies.get("userID");

  const [showModel, setShowModel] = useState(false);
  const [albumData, setalbumData] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [albumToDelete, setAlbumToDelete] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { album, loading } = useSelector((state) => state.GallerySlice);

  const handleClick = (albumItem) => {
    navigate("/albums-gallery", {
      state: {
        album: albumItem,
        from: location.pathname
      }
    });
  };
  

  const handleEdit = (albumItem) => {
    setalbumData(albumItem);
    setShowModel(true);
  };

  const handleDelete = async () => {
    if (albumToDelete) {
      const response = await dispatch(
        deleteUpdate({ id: albumToDelete.album_id })
      );

      if (response.payload?.status === "success") {
        toast.success("Album deleted successfully!");
        await dispatch(albumGet({ company_id }));
        setAlbumToDelete(null);
        setDeleteConfirmModal(false);
      } else {
        toast.error("Error while deleting album");
      }
    }
  };

  if (typeof album?.result === "string") {
    toast.error(album.result);
  }

  return (
    <>
      {loading && <Lodderr />}

      <EditAlbumModal
        showModal={showModel}
        closeModal={() => setShowModel(false)}
        albumData={albumData}
      />

      <div className=" mb-4">
        {/* <div className="d-flex justify-content-end mb-1 mt-1">
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => navigate(-1)}
          >
            <i className="bx bx-left-arrow-alt"></i> Back
          </button>
        </div> */}

        <div className="row">
          {Array.isArray(album?.result) ? (
            album.result.map((albumItem) => (
              <div key={albumItem.album_id} className="col-md-3 mb-3 ">
                <div className="album-card h-100 position-relative">
                  <div className="position-relative d-flex justify-content-end">
                    <div className="position-relative text-end">
                      {UserID == albumItem?.data[0]?.member_id &&
                        company_id == albumItem?.data[0]?.company_id && (
                          <>
                            <button
                              className="btn btn-light btn-sm"
                              onClick={() =>
                                setOpenDropdownId(
                                  openDropdownId === albumItem.album_id
                                    ? null
                                    : albumItem.album_id
                                )
                              }
                            >
                              <i className="bx bx-dots-vertical-rounded fs-4"></i>
                            </button>

                            {openDropdownId === albumItem.album_id && (
                              <div
                                className="dropdown-menu show mt-2 p-2 border-0 shadow rounded"
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: "100%",
                                  minWidth: "160px",
                                  zIndex: 1050,
                                }}
                              >
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => {
                                    setOpenDropdownId(null);
                                    handleEdit(albumItem);
                                  }}
                                >
                                  <i className="bx bx-edit-alt me-2"></i> Edit
                                </button>
                                <button
                                  className="dropdown-item d-flex align-items-center text-danger"
                                  onClick={() => {
                                    setAlbumToDelete(albumItem);
                                    setDeleteConfirmModal(true);
                                    setOpenDropdownId(null);
                                  }}
                                >
                                  <i className="bx bx-trash me-2"></i> Delete
                                </button>
                              </div>
                            )}
                          </>
                        )}
                    </div>
                  </div>

                  <div
                    onClick={() => handleClick(albumItem)}
                    style={{ cursor: "pointer" }}
                  >
                    <h5 className="album-title m-1 mb-5 text-center">
                      {albumItem.title}
                    </h5>
                    <div className="media-container flex-wrap gap-2">
                      {albumItem.data?.slice(0, 4).map((item, index) => (
                        <div key={index} className="media-item">
                          {item.extension_type === "image" && (
                            <img
                              src={item.file_url}
                              alt="Album"
                              className="img-fluid media-image"
                              style={{
                                width: "100%",
                                height: "100px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          {item.extension_type === "video" && (
                            <video
                              src={item.file_url}
                              muted
                              className="img-fluid media-video"
                              style={{
                                width: "100%",
                                height: "100px",
                                objectFit: "cover",
                              }}
                            ></video>
                          )}
                          {item.extension_type === "audio" && (
                            <i
                              className="bi bi-music-note media-audio d-flex align-items-center justify-content-center bg-light"
                              style={{
                                width: "100%",
                                height: "100px",
                                fontSize: "2rem",
                                borderRadius: "5px",
                              }}
                            ></i>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center mt-4">No albums found.</div>
          )}
        </div>
      </div>

      {deleteConfirmModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDeleteConfirmModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this album?</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setDeleteConfirmModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlbumsCard;
